import React from "react";
import { Outlet } from "react-router-dom";
import ScalableWrapper from "../ScalableWrapper";
import Header from "./header";

const SiteLayout = () => {
  return (
    <ScalableWrapper>
      <div className="app">
        <Header />
        <Outlet />
      </div>
    </ScalableWrapper>
  );
};

export default SiteLayout;


